import React from 'react';
import { Avatar, IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface UserAvatarProps {
  initials?: string;
  size?: number;
  fontSize?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  tooltip?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  size = 32,
  fontSize = '0.875rem',
  onClick,
  tooltip = "Profile"
}) => {
  const theme = useTheme();

  const avatar = (
    <Avatar
      sx={{
        width: size,
        height: size,
        backgroundColor: theme.palette.primary.main,
        fontSize
      }}
    >
    </Avatar>
  );

  if (onClick) {
    return (
      <Tooltip title={tooltip}>
        <IconButton onClick={onClick}>
          {avatar}
        </IconButton>
      </Tooltip>
    );
  }

  return avatar;
};

export default UserAvatar;